import { Modal } from "@mantine/core";
import { useChatAvailability } from "hooks/useChatAvailability";
import { useChatPanelStore } from "stores/chatPanel";
import { ChatContent } from "./ChatContent";
import ChatContextProvider from "./providers/ChatContextProvider";

export const ChatModal: React.FC = ({}) => {
  const isPanelOpen = useChatPanelStore(store => store.isPanelOpen);
  const setIsPanelOpen = useChatPanelStore(store => store.setIsPanelOpen);
  const isChatAvailable = useChatAvailability();
  const setPanelDiscussionId = useChatPanelStore(
    store => store.setPanelDiscussionId
  );

  const handleClose = () => {
    setIsPanelOpen(false);
    setPanelDiscussionId(null);
  };

  if (!isChatAvailable) return null;

  return (
    <Modal.Root
      opened={isPanelOpen}
      onClose={handleClose}
      fullScreen
      padding={0}
      zIndex={300}
      ff={"Work Sans"}
    >
      <Modal.Content className="bg-gray-lightest p-0 flex flex-col h-dvh w-full">
        <Modal.Body className="p-0 flex-1 min-h-0 flex flex-col">
          <ChatContextProvider>
            <ChatContent />
          </ChatContextProvider>
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  );
};

export default ChatModal;
